import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const IssueTypesViewTopBar = memo(() => {
	return <BaseTopBar />
})
IssueTypesViewTopBar.displayName = "IssueTypesViewTopBar"
